export default "__VITE_ASSET__BfUwgFRf__"